<!--
  PurchaseFormModal: alta y edición de comprobantes de compra, con el pago al generarlos.

  ENTRADA
    Props: no tiene.
    Métodos públicos (por ref):
      add()                          Abre el alta vacía.
      edit(item)                     Abre la edición de un comprobante ya cargado (item del listado).
      addFromServiceActivity(id)     Abre el alta vinculada a una renovación de servicio. Si id es null, es un alta normal.
                                     Al guardar vincula el comprobante y navega al monitor de servicios.
      generateFromRemit(remitsID)    Abre el alta precargada con el remito de compra. Devuelve true si recibió un id;
                                     sin id solo limpia el remito pendiente. Al guardar o cancelar vuelve a remitos de compra.
      invoiceFromBankMovements(ids)  Abre el alta como resumen bancario con esos movimientos de caja.
                                     Al guardar o cancelar vuelve a los movimientos de la cuenta.
      close()                        Cierra el modal sin confirmar.

  SALIDA
    Eventos:
      @saved(response)         Se guardó. La vista recarga lo que corresponda.
      @currency-change(moneda) Cambió la moneda del formulario. La vista la usa hoy para mostrar importes.
    Efectos:
      Guarda con agregarComprobante o editarComprobante. EL PAGO DEL ALTA GENERA MOVIMIENTOS REALES DE CAJA.
      Vincula remitos y renovaciones de servicio. Navega al origen según se indicó arriba.

  USOS
    Vista: <PurchaseFormModal ref="purchaseForm" @saved="filterPurchase()" @currency-change="crud.form.currency = $event" />
    Alta:           this.$refs.purchaseForm.add()
    Edición:        this.$refs.purchaseForm.edit(item)
    Desde remito:   this.$refs.purchaseForm.generateFromRemit(this.$route.params.remitsID)
    Desde banco:    this.$refs.purchaseForm.invoiceFromBankMovements(ids)
    Desde servicio: this.$refs.purchaseForm.addFromServiceActivity(this.$route.query.services_activity || null)
    Hoy se invoca desde purchase/staff/purchase.vue: botón, listado, drawer, ?new=1 de la paleta y rutas de remito y banco.

  DEPENDENCIAS Y PERMISOS
    Componentes: FindObject, FinanceSUB, VoucherRelation, FormWizard.
    La vista lee los parámetros de ruta y limpia la URL. isGenerateFromRemitsRoute conserva la lectura original de $route.
    Archivo, datos extra, remitos vinculados y detalle siguen en la vista.
    No controla permisos de apertura: quien lo invoca decide. Sí oculta categoría e info de pago según el permiso del usuario.
-->
<template>
  <div>
    <!-- CRUD MAIN -->
    <b-modal v-model="modal.form.active"
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            size="xl"
            :key="modal.form._id"
            :id="modal.form._id">
      <div slot="modal-header" minimize class="app-modal-header">
        <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
        <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
      </div>

      <b-alert show variant="info" v-if="crud.form.remits_id" class="crud_purchase_alert_from">
        <b>Desde {{getRemitReference}}</b>
      </b-alert>

      <form-wizard  title=""
                    subtitle=""
                    nextButtonText="Siguiente"
                    backButtonText="Atrás"
                    finishButtonText="Guardar"
                    color="#2f353a"
                    shape="tab"
                    @on-complete="preSave"
                    class="crud-purchase-wizard">

        <tab-content title="General" icon="fa fa-edit" :before-change="purchaseValidDetailGeneral">
          <b-row>
            <b-col md="4">
              <b-form-group label="Fecha">
                <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es"></b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Fecha Vencimiento">
                <b-form-datepicker size="sm" v-model="crud.form.date_expiration" placeholder="Fecha Vencimiento" local="es"></b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Fecha Imputación">
                <b-form-datepicker size="sm" v-model="crud.form.date_imputation" placeholder="Fecha Imputación" local="es"></b-form-datepicker>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <FindObject type="suppliers"
                          render="search"
                          @select-object="loadSuppliers($event)"
                          :valueID="crud.form.suppliers_id"
                          :key="'finder_suppliers_'+componentKey"
                          :where="conditionSuppliersActive"
                          :disabled="crud.form.id>0 || crud.form.remits_id>0" />
            </b-col>
            <b-col md="4">
              <FindObject tag="Punto de Venta (Imputación)"
                          type="erpPointsSales"
                          render="search"
                          display="full_identification"
                          @select-object="loadPointsSales($event)"
                          :valueID="crud.form.points_sales_id"
                          :key="'finder_point_sale_'+componentKeyAlt"
                          auto-select-single
                          :disabled="crud.form.id>0 || crud.form.remits_id>0"
                          :where="conditionPointsSalesActive" />
            </b-col>
            <b-col md="4">
              <FindObject type="currency"
                          render="search"
                          auto-select-single
                          @select-object="loadCurrency($event)"
                          :key="'finder_currency_'+componentKey"
                          :valueID="crud.form.currency_id"
                          :where="conditionCurrencyActive"
                          :disabled="crud.form.id>0"/>
            </b-col>
          </b-row>
          <b-row v-if="canShowPurchaseCategory || canShowPurchaseInfoPayment">
            <b-col md="4" v-if="canShowPurchaseCategory">
              <FindObject type="purchaseCategory"
                          render="search"
                          @select-object="loadPurchaseCategory($event)"
                          :valueID="crud.form.purchase_category_id"/>
            </b-col>
            <b-col md="4" v-if="canShowPurchaseInfoPayment">
              <FindObject type="purchaseInfoPayment"
                          render="search"
                          @select-object="loadInfoPayment($event)"
                          :valueID="crud.form.info_payment_id"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row align-h="between">
            <b-col md="9" v-if="crud.form.suppliers_id">
              <div class="crud-purchase-voucher-fields">
                <div class="crud-purchase-voucher-fields__title">
                  <AppIcon name="receipt" /> Datos del comprobante
                </div>
                <div class="mb-2" v-if="bankExpense"><AppIcon name="account_balance" class="mr-1" /><small>{{ bankExpense.reference }}</small></div>
                <b-row>
                <b-col md="4">
                  <b-form-group label="Tipo">
                    <b-form-select v-model="crud.form.types_vouchers_id"
                                  :options="arr.select.typeVouchers"
                                  @change="setLetter($event)"
                                  size="sm"
                                  :disabled="crud.form.id>0">
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="Punto de Venta">
                    <app-text-input v-model.number="crud.form.point_sale"
                                    type="text"
                                    inputmode="numeric"
                                    :allowed-pattern="/[0-9]/g"
                                    size="sm"
                                    maxlength="6" />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="Número">
                    <app-text-input v-model.number="crud.form.number"
                                    type="text"
                                    inputmode="numeric"
                                    :allowed-pattern="/[0-9]/g"
                                    size="sm"
                                    maxlength="10" />
                  </b-form-group>
                </b-col>
              </b-row>
              </div>
            </b-col>
            <b-col md="3" :offset="crud.form.suppliers_id ? 0 : 9">
              <b-form-group label="Importe Final" description="Ingrese el importe final de la factura">
                <b-input-group size="md" prepend="$">
                  <app-number-input v-model="crud.form.amount_total" placeholder="Ingrese el importe final" />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </tab-content>

        <tab-content title="Impuestos" icon="fa fa-percent" :before-change="purchaseValidItemDetail" v-if="crud.form.letter == 'A'" :key="'tab_b_'+componentKey">
          <b-tabs class="crud-purchase-tax-tabs" content-class="pt-3">
            <b-tab active>
              <template #title>
                <AppIcon name="percent" class="mr-1" /> IVA discriminado
                <b-badge pill variant="secondary" class="ml-1">{{ crud.form.ivaDetail.detail.length }}</b-badge>
              </template>

              <div class="crud-purchase-tax-guide">
                <AppIcon name="info-circle" />
                <span><b>¿Cómo cargar el IVA?</b> Elegí la alícuota, ingresá el neto gravado y verificá el importe calculado antes de agregarlo al comprobante.</span>
              </div>

              <div class="crud-purchase-tax-form">
                <b-row align-v="end">
                  <b-col md="3">
                    <b-form-group label="Condición IVA">
                      <b-form-select v-model="crud.form.ivaDetail.iva_condition_id"
                                    :options="arr.select.ivaCondition"
                                    @input="changeIvaCondition($event)"
                                    size="sm">
                      </b-form-select>
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="Neto gravado">
                      <b-input-group size="sm" prepend="$">
                        <app-number-input v-model="crud.form.ivaDetail.net" @change="changeNet()" placeholder="Ingrese el neto" />
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="Importe IVA" v-if="crud.form.ivaDetail.iva_condition">
                      <b-input-group size="sm" prepend="$">
                        <app-number-input v-model="crud.form.ivaDetail.iva"
                                          :key="'iva_amount_' + crud.form.ivaDetail.iva_condition_id"
                                          placeholder="Ingrese el IVA"
                                          @keyup.enter.native="addItemIVA()"
                                          :disabled="!parseFloat(crud.form.ivaDetail.iva_condition.aliquot)">
                        </app-number-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col md="3" class="d-flex align-items-end">
                    <b-button size="sm" variant="primary" class="crud-purchase-tax-form__add" @click="addItemIVA()">
                      <AppIcon name="plus-circle" class="mr-1" /> Agregar IVA
                    </b-button>
                  </b-col>
                </b-row>
              </div>

              <div class="crud-purchase-tax-detail">
                <div v-if="crud.form.ivaDetail.detail && crud.form.ivaDetail.detail.length" class="crud-purchase-tax-table">
                  <div class="crud-purchase-tax-table__heading">
                    <span><AppIcon name="percent" /> IVA incorporado</span>
                    <b-badge pill variant="secondary">{{ crud.form.ivaDetail.detail.length }}</b-badge>
                  </div>
                  <b-table-simple hover small responsive class="app-table app-table--compact mb-0" v-if="crud.form.ivaDetail.detail && crud.form.ivaDetail.detail.length">
                    <b-thead>
                      <b-tr>
                        <b-th width="25%" class="text-center">Alicuota</b-th>
                        <b-th width="20%" class="text-right">Neto</b-th>
                        <b-th width="20%" class="text-right">IVA</b-th>
                        <b-th width="20%" class="text-right">Total</b-th>
                        <b-th width="15%" class="text-center"></b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody v-for="(item, index) in crud.form.ivaDetail.detail" :key="'iva_' + index">
                      <b-tr>
                        <b-td class="text-center align-middle">
                          <b-badge pill class="crud-purchase-tax-label">
                            <AppIcon name="percent" /> {{item.iva_condition.name}}
                          </b-badge>
                        </b-td>
                        <b-td class="text-right align-middle">
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(item.net)}}
                        </b-td>
                        <b-td class="text-right align-middle">
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(item.iva)}}
                        </b-td>
                        <b-td class="text-right align-middle">
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(parseFloat(item.net) + parseFloat(item.iva))}}
                        </b-td>
                        <b-td class="text-center align-middle">
                          <b-button size="sm"
                                    variant="link"
                                    class="app-table-icon-btn app-table-icon-btn--danger crud-purchase-tax-remove-btn"
                                    v-b-tooltip.hover.left
                                    title="Quitar"
                                    @click="removeItemIVA(index)">
                            <AppIcon name="x" label="Quitar" />
                          </b-button>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </div>
                <EmptyState v-else
                            icon="percent"
                            title="Todavía no agregaste IVA discriminado"
                            description="Cargá una alícuota y el neto gravado para incorporarlo al comprobante." />
              </div>

            </b-tab>

            <b-tab>
              <template #title>
                <AppIcon name="receipt_long" class="mr-1" /> Percepciones
                <b-badge pill variant="secondary" class="ml-1">{{ crud.form.percepcionesDetail.detail.length }}</b-badge>
              </template>

              <div class="crud-purchase-tax-guide">
                <AppIcon name="info-circle" />
                <span><b>¿Cómo cargar una percepción?</b> Elegí el concepto informado por el proveedor, ingresá el importe retenido y agregalo para que forme parte del total del comprobante.</span>
              </div>

              <div class="crud-purchase-tax-form">
                <b-row align-v="end">
                  <b-col md="5">
                  <b-form-group label="Percepción">
                    <b-form-select v-model="crud.form.percepcionesDetail.percepciones_id"
                                  :options="arr.select.percepciones"
                                  @change="changePercepciones($event)"
                                  size="sm">
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col md="3">
                  <b-form-group label="Importe de la percepción">
                    <b-input-group size="sm" prepend="$">
                      <app-number-input v-model="crud.form.percepcionesDetail.percepcion"
                                        placeholder="Ingrese el total"
                                        @keyup.enter.native="addItemPercepcion()" />
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="4" class="d-flex align-items-end">
                  <b-button size="sm" variant="primary" class="crud-purchase-tax-form__add" @click="addItemPercepcion()">
                    <AppIcon name="plus-circle" class="mr-1" /> Agregar percepción
                  </b-button>
                </b-col>
                </b-row>
              </div>

              <div class="crud-purchase-tax-detail">
                <div v-if="crud.form.percepcionesDetail.detail.length" class="crud-purchase-tax-table">
                  <div class="crud-purchase-tax-table__heading">
                    <span><AppIcon name="receipt_long" /> Percepciones incorporadas</span>
                    <b-badge pill variant="secondary">{{ crud.form.percepcionesDetail.detail.length }}</b-badge>
                  </div>
                  <b-table-simple hover small responsive class="app-table app-table--compact mb-0" v-if="crud.form.percepcionesDetail.detail.length">
                    <b-thead>
                      <b-tr>
                        <b-th width="25%" class="text-center">Percepción</b-th>
                        <b-th width="20%" class="text-right">Total</b-th>
                        <b-th width="15%" class="text-center"></b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody v-for="(item, index) in crud.form.percepcionesDetail.detail" :key="'percepciones_' + index">
                      <b-tr>
                        <b-td class="text-center align-middle">
                          <b-badge pill class="crud-purchase-tax-label" v-if="item.percepciones">
                            <AppIcon name="receipt_long" /> {{item.percepciones.name}}
                          </b-badge>
                        </b-td>
                        <b-td class="text-right align-middle">
                          {{ Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(item.percepcion) }}
                        </b-td>
                        <b-td class="text-center align-middle">
                          <b-button size="sm"
                                    variant="link"
                                    class="app-table-icon-btn app-table-icon-btn--danger crud-purchase-tax-remove-btn"
                                    v-b-tooltip.hover.left
                                    title="Quitar"
                                    @click="removeItemPercepcion(index)">
                            <AppIcon name="x" label="Quitar" />
                          </b-button>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </div>
                <EmptyState v-else
                            icon="receipt_long"
                            title="Todavía no agregaste percepciones"
                            description="Seleccioná el concepto e ingresá su importe para incorporarlo al comprobante." />
              </div>
            </b-tab>
          </b-tabs>

          <div class="crud-purchase-totals crud-purchase-totals--taxes mt-3">
                <div class="crud-purchase-totals__header">
                  <span><AppIcon name="receipt" /> Resumen del comprobante</span>
                  <span>Importe declarado: <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(this.crud.form.amount_total)}}</b></span>
                </div>
                <div class="crud-purchase-totals__row">
                  <span class="crud-purchase-totals__label">Subtotal</span>
                  <span class="crud-purchase-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(this.getSubtotal())}}</span>
                </div>
                <div class="crud-purchase-totals__row">
                  <span class="crud-purchase-totals__label">IVA</span>
                  <span class="crud-purchase-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(this.getIvaTotal())}}</span>
                </div>
                <div class="crud-purchase-totals__row">
                  <span class="crud-purchase-totals__label">Percepciones</span>
                  <span class="crud-purchase-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(this.getPercepcionesTotal())}}</span>
                </div>
                <div class="crud-purchase-totals__row crud-purchase-totals__row--total">
                  <span class="crud-purchase-totals__label">Importe Final</span>
                  <span class="crud-purchase-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(this.getTotal())}}</span>
                </div>
                <div class="crud-purchase-totals__row crud-purchase-totals__row--difference"
                     :class="this.getDiffTotal()==0 ? 'crud-purchase-totals__row--balanced' : 'crud-purchase-totals__row--unbalanced'">
                  <span class="crud-purchase-totals__label">
                    <AppIcon :name="this.getDiffTotal()==0 ? 'check-circle' : 'info-circle'" class="mr-1" />
                    <span v-if="this.getDiffTotal()==0">Diferencia (APROBADO)</span>
                    <span v-else-if="this.getDiffTotal()>0">Diferencia (EXCEDIDO)</span>
                    <span v-else>Diferencia (FALTAN)</span>
                  </span>
                  <span class="crud-purchase-totals__value" :class="this.getDiffTotal()==0 ? 'text-success' : 'text-danger'">
                    <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:getCurrency}).format(this.getDiffTotal())}}</b>
                  </span>
                </div>
          </div>
        </tab-content>

        <tab-content title="Facturas" icon="fa fa-link" :before-change="purchaseValidCrudRelation" v-if="crud.form.types_vouchers && (crud.form.types_vouchers.reference=='notacredito' || crud.form.types_vouchers.reference=='credito-nd')" :key="'tab_c_'+componentKey">
          <b-row>
            <b-col v-if="crud.form.currency">
              <VoucherRelation  :supplier_id="crud.form.suppliers_id"
                                :point_sale_id="crud.form.points_sales_id"
                                :details="crud.form.invoiceRelated"
                                :amount="crud.form.amount_total"
                                :currency="crud.form.currency"
                                v-if="crud.form.currency"
                                @getInvoice="getInvoiceRelated($event)" />
            </b-col>
          </b-row>
        </tab-content>

        <tab-content title="Observaciones" icon="fa fa-flag-checkered" :key="'tab_f_'+componentKey">
          <b-row>
            <b-col md="12">
              <b-form-group label="Observaciones">
                <app-textarea
                  v-model="crud.form.observations"
                  placeholder="Ingresar las observaciones..."
                  rows="3"
                  max-rows="6"
                ></app-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </tab-content>

      </form-wizard>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" class="mr-1" @click="cancel()">Cancelar</b-button>
      </div>
    </b-modal>

    <!-- CRUD PAYMENT -->
    <b-modal v-model="modal.payment.active"
            no-close-on-backdrop
            hide-header-close
            size="md">

      <div slot="modal-header" minimize class="app-modal-header">
        <span class="app-modal-header__icon"><AppIcon name="money" /></span>
        <h5 class="app-modal-header__title">{{this.modal.payment.title}}</h5>
      </div>

      <b-card>
        <b-row>
          <b-col md="12">
            <b-alert show variant="info" v-if="bankExpense">
              Se paga con los movimientos ya debitados de <b>{{ bankExpense.cash ? bankExpense.cash.name : '' }}</b>
              por <b>{{ Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(bankExpense.amount) }}</b>:
              no se genera otro débito.<br>
              <small>{{ bankExpense.reference }}</small>
            </b-alert>
            <FinanceSUB @getFinances="storeFinances($event)"
                        v-else-if="crud.form.suppliers_id && crud.form.points_sales_id"
                        :points_sales="crud.form.points_sales"
                        :amount_impute="crud.form.amount_total"
                        :reset="resetControl"/>
          </b-col>
          <b-col md="12" class="mt-4">
            <b-alert show variant="info" v-if="crud.form.payment && !parseFloat(crud.form.payment.total)">
              Si el <b>comprobante se paga</b> en el momento, cargue el <b>detalle del pago.</b><br><br>
              <i>En caso de no cargar el pago, el comprobante quedará en cuenta corriente <b>pendiente de imputación</b></i>
            </b-alert>
            <div v-else>
              <b-alert show variant="success" v-if="$funciones.compareMoney(crud.form.payment.total, crud.form.amount_total) === 0">
                Comprobante Saldado
              </b-alert>
              <div v-else>
                <b-alert show variant="warning" v-if="$funciones.compareMoney(crud.form.payment.total, crud.form.amount_total) > 0">
                  El importe pagado es mayor al total del comprobante.<br>
                  <b>Importe Comprobante</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(this.crud.form.amount_total)}}<br>
                  <b>Importe Pagado</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(this.crud.form.payment.total)}}<br><br>
                  <i>El saldo quedará en cuenta corriente pendiente de imputación a favor de la empresa</i>
                </b-alert>
                <b-alert show variant="danger" v-if="$funciones.compareMoney(crud.form.payment.total, crud.form.amount_total) < 0">
                  El importe pagado es menor al total del comprobante.<br>
                  <b>Importe Comprobante</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(this.crud.form.amount_total)}}<br>
                  <b>Importe Pagado</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(this.crud.form.payment.total)}}<br><br>
                  <i>El comprobante quedará en cuenta corriente pendiente de imputación</i>
                </b-alert>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" class="mr-1" @click="cancelPayment()">Cancelar</b-button>
        <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" />Finalizar</b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import serviceAPI from '../services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import FindObject from '@/components/inc/find/findObject'
  import VoucherRelation from './detailInvoice'
  import FinanceSUB from '@/components/inc/finances/sub'
  import moment from 'moment'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'

  export default {
    name: 'PurchaseFormModal',
    components: {
      FindObject,
      FormWizard,
      TabContent,
      VoucherRelation,
      FinanceSUB,
    },
    data: () => {
      return {
        access: {
            module_id: Modules.COMPRAS,
            profile_id: Profiles.PERSONAL,
        },
        crud: {
          form: {
            id: 0,
            date: '',
            date_expiration: '',
            date_imputation: '',
            types_vouchers_id: 0,
            types_vouchers: null,
            letter: '',
            point_sale: 0,
            number: 0,
            observations: '',
            staff_id: 0,
            suppliers_id: 0,
            suppliers: null,
            currency_id: 0,
            currency: null,
            remits_id: 0,
            remits: null,
            points_sales_id: 0,
            points_sales: null,
            detail: [],
            ivaDetail: {
              net: 0,
              iva: 0,
              iva_condition_id: 0,
              iva_condition: null,
              detail: [],
            },
            percepcionesDetail: {
              percepcion: 0,
              percepciones_id: 0,
              percepciones: null,
              detail: [],
            },
            invoiceRelated: [],
            amount_total: 0,
            purchase_category_id: 0,
            purchase_category: null,
            info_payment_id: 0,
            info_payment: null,
            payment: [],
            showPayment: true,
          },
        },
        modal: {
          form: {
            active: false,
            title: '',
          },
          payment: {
            active: false,
            title: '',
          },
        },
        arr: {
          typeVouchers: [],
          ivaCondition: [],
          percepciones: [],
          select: {
            typeVouchers: [],
            ivaCondition: [],
            percepciones: [],
          },
        },
        invoiceFromRemitsActive: false,
        purchaseGenerationOrigin: null,
        // movimientos del extracto que se pagan con este comprobante (Finanzas › Movimientos)
        bankExpense: null,
        // renovación de servicio a la que se vincula el comprobante al guardarlo
        // (alta abierta desde el Monitor de servicios con ?services_activity=)
        servicesActivityId: null,
        voucherRequestKey: 0,
        pendingVoucherNameDefault: null,
        pendingVoucherNamePrefixDefault: null,
        componentKey: 0,
        componentKeyAlt: 0,
        resetControl: false,
      }
    },
    computed: {
      conditionCurrencyActive() {
        return [{field: 'status', condition: true}]
      },
      // CONDITIONS SELECT
      conditionSuppliersActive(){
        return [{field: 'active', condition: true}];
      },
      conditionPointsSalesActive() {
        return [{field: 'active', condition: true}];
      },
      getRemitReference() {
        if(this.crud.form.remits && this.crud.form.remits.type_voucher && this.crud.form.remits.point_sale && this.crud.form.remits.number) {
          return this.crud.form.remits.type_voucher.name + ' ' + this.crud.form.remits.point_sale.toString().padStart(4,'0') + '-' + this.crud.form.remits.number.toString().padStart(8,'0')
        } else {
          return 'ID #' + this.crud.form.remits_id
        }
      },
      canShowPurchaseCategory() {
        return Helper.showAccessView(this.access, 'purchaseCategory')
      },
      canShowPurchaseInfoPayment() {
        return Helper.showAccessView(this.access, 'infoPayment')
      },
      // CURRENCY
      getCurrency() {
        if(this.crud.form.currency) {
          return this.crud.form.currency.code
        } else {
          return 'ARS'
        }
      },
    },
    watch: {
      'crud.form.currency': function (value) {
        this.$emit('currency-change', value)
      },
    },
    methods: {
      // API PUBLICA PARA LA VISTA
      close() {
        this.modal.form.active = false
      },
      addFromServiceActivity(id) {
        this.add()
        this.servicesActivityId = id
      },
      generateFromRemit(remitsID) {
        this.crud.form.remits_id = remitsID
        if(this.crud.form.remits_id) {
          this.purchaseGenerationOrigin = 'remits'
          this.invoiceFromRemits()
          return true
        }
        return false
      },

      // Confirm estándar: header con ícono + tinte suave (.app-confirm-header)
      // en vez de header-bg-variant sólido, size 'sm' siempre, y
      // okVariant/headerClass según sea o no destructiva.
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      forceRender() {
        this.componentKey += 1;
      },
      forceRenderAlt() {
        this.componentKeyAlt += 1;
      },

      /****************
       * RETORNO *
       * **************/
      isGenerateFromRemitsRoute() {
        return this.purchaseGenerationOrigin == 'remits' || (this.$route.name == 'PurchaseStaffPurchaseGenerateByRemits' && !!this.$route.params.remitsID)
      },
      returnToPurchaseRemits() {
        if (!this.isGenerateFromRemitsRoute()) return
        this.purchaseGenerationOrigin = null
        this.goPurchaseRemits()
      },
      goPurchaseRemits() {
        this.$router.push({ name: 'PurchaseStaffPurchaseRemits' }, () => {
          window.__suppressBeforeUnload = true
          window.location.reload()
        })
      },
      invoiceFromBankMovements(ids) {
        serviceAPI.datosMovimientosBancarios(ids)
        .then((response) => {
          var data = response.data
          this.add()
          this.purchaseGenerationOrigin = 'bankExpense'
          this.bankExpense = data
          this.pendingVoucherNameDefault = 'RESUMEN BANCARIO'
          this.crud.form.date = data.date
          this.crud.form.date_expiration = data.date
          this.crud.form.date_imputation = data.date
          this.crud.form.observations = data.reference
          // no hay factura del banco: numeración propia, editable (Compras no acepta punto de venta 0)
          this.crud.form.point_sale = 1
          this.crud.form.number = data.number
          this.crud.form.amount_total = data.amount
          if(data.supplier) {
            this.crud.form.suppliers = data.supplier
            this.crud.form.suppliers_id = data.supplier.id
          } else {
            this.$awn.warning('La cuenta no tiene proveedor (banco) configurado: elegilo acá o cargalo en Cajas y cuentas.')
          }
          this.modal.form.title = 'Resumen bancario'
          this.forceRender()
          this.forceRenderAlt()
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        })
      },
      // Neto e IVA de los movimientos, sin recalcular; la alícuota es la más cercana a esa
      // relación. La percepción queda cargada para elegir de cuál se trata.
      applyBankExpenseTaxes() {
        if(!this.bankExpense || !this.arr.ivaCondition || !this.arr.ivaCondition.length) return
        if(!this.crud.form.ivaDetail || !this.crud.form.ivaDetail.detail || this.crud.form.ivaDetail.detail.length) return

        var net = parseFloat(this.bankExpense.net)
        var iva = parseFloat(this.bankExpense.iva)
        if(net > 0) {
          var rate = (iva * 100) / net
          var condition = this.arr.ivaCondition.reduce((best, element) => {
            return Math.abs(parseFloat(element.aliquot) - rate) < Math.abs(parseFloat(best.aliquot) - rate) ? element : best
          })
          this.crud.form.ivaDetail.detail.push({ net: net, iva: iva, iva_condition: condition, iva_condition_id: condition.id })
        }
        if(parseFloat(this.bankExpense.perception) > 0 && this.crud.form.percepcionesDetail) {
          this.crud.form.percepcionesDetail.percepcion = parseFloat(this.bankExpense.perception)
        }
      },
      bankExpensePayment() {
        var amount = parseFloat(this.bankExpense.amount)
        return {
          total: amount,
          totalFormat: Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrency}).format(amount),
          cash: {
            total: amount,
            detail: this.bankExpense.movements.map(movement => ({
              cash: this.bankExpense.cash,
              cash_id: this.bankExpense.cash.id,
              total: movement.amount,
              finances_cash_detail_id: movement.id,
            })),
          },
          cheques: { total: 0, detail: null },
        }
      },
      returnToBankExpense() {
        var expense = this.bankExpense
        this.bankExpense = null
        this.purchaseGenerationOrigin = null
        if(!expense) return
        this.$router.push({
          name: 'FinancesStaffCashDetail',
          params: { finances_cash_id: expense.cash.id, date_start: expense.date_from },
        }).catch(() => {})
      },
      // PROCESS ADMINISTRATIVE
      invoiceFromRemits() {
        if(this.invoiceFromRemitsActive) {
          return false
        }
        this.invoiceFromRemitsActive = true

        let remitsID = this.crud.form.remits_id
        let loader = this.$loading.show();

        serviceAPI.mostrarRemito(remitsID)
        .then((response) => {
          var remit = response.data

          if(!remit) {
            loader.hide()
            this.$awn.alert("No se encontró el remito");
            this.goPurchaseRemits()
            this.invoiceFromRemitsActive = false
            return false
          }

          if(remit.purchase_id || remit.purchase) {
            loader.hide()
            this.$awn.alert("El remito ya se encuentra facturado");
            this.goPurchaseRemits()
            this.invoiceFromRemitsActive = false
            return false
          }

          this.resetFormFields()
          this.applyRemitPreset(remit)
          this.modal.form._id = Math.random().toString(36).slice(2, 8)
          this.modal.form.active = true
          this.modal.form.title = 'Comprobante de Proveedor'
          this.invoiceFromRemitsActive = false

          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.crud.form.remits_id = 0
          this.invoiceFromRemitsActive = false
          this.$awn.alert(Error.showError(error));
        })
      },
      applyRemitPreset(remit) {
        this.crud.form.date = moment(remit.date).format('YYYY-MM-DD')
        this.crud.form.date_expiration = moment(remit.date).format('YYYY-MM-DD')
        this.crud.form.date_imputation = moment(remit.date).format('YYYY-MM-DD')

        if(remit.supplier) {
          this.crud.form.suppliers = remit.supplier
          this.crud.form.suppliers_id = remit.supplier.id
        }

        if(remit.points_sales) {
          this.crud.form.points_sales = remit.points_sales
          this.crud.form.points_sales_id = remit.points_sales.id
        }

        // Punto de venta "No Informado" (nd=true, no se reporta a ARCA) => el comprobante
        // se predefine como Gasto ND; en cualquier otro caso, la primera "Factura A/B/C"
        // que aparezca entre los tipos disponibles para ese proveedor+punto de venta (no
        // siempre está la A — depende de la condición fiscal del proveedor).
        // Se guarda acá porque loadTypeVouchersBySuppliers() recién trae la lista de
        // comprobantes disponibles después (la dispara el FindObject de proveedor/punto de
        // venta al reaccionar a estos mismos campos, de forma asincrónica).
        if(remit.points_sales && remit.points_sales.nd) {
          this.pendingVoucherNameDefault = 'GASTO ND'
          this.pendingVoucherNamePrefixDefault = null
        } else {
          this.pendingVoucherNameDefault = null
          this.pendingVoucherNamePrefixDefault = 'FACTURA'
        }

        if(remit.point_sale !== undefined && remit.point_sale !== null) {
          this.crud.form.point_sale = remit.point_sale
        }

        if(remit.number !== undefined && remit.number !== null) {
          this.crud.form.number = remit.number
        }

        this.crud.form.remits_id = remit.id
        this.crud.form.remits = remit

        const estimatedTotal = this.getRemitAmountTotal(remit)
        if(estimatedTotal > 0) {
          this.crud.form.amount_total = estimatedTotal
        }

        this.forceRender()
        this.forceRenderAlt()

        const remitVoucher = (remit.type_voucher && remit.point_sale)
          ? remit.type_voucher.name + ' ' + remit.point_sale.toString().padStart(4,'0') + '-' + remit.number.toString().padStart(8,'0')
          : 'ID #' + remit.id
        this.crud.form.observations = 'Remito: ' + remitVoucher
      },
      getRemitAmountTotal(remit) {
        var total = 0
        const addItem = (element) => {
          var net = parseFloat(element.quantity) * parseFloat(element.price_cost || 0)
          if(!isNaN(net)) {
            var aliquot = (element.iva_condition && element.iva_condition.aliquot)
              ? parseFloat(element.iva_condition.aliquot)
              : 0
            total += net * (1 + aliquot / 100)
          }
        }
        if(remit.details && remit.details.products) {
          remit.details.products.forEach(addItem)
        }
        if(remit.details && remit.details.products_compound) {
          remit.details.products_compound.forEach(addItem)
        }
        return parseFloat(total.toFixed(2))
      },

      // ABM MAIN
      resetFormFields() {
        this.crud.form.id = 0
        this.crud.form.date = moment().format('YYYY-MM-DD')
        this.crud.form.date_expiration = moment().format('YYYY-MM-DD')
        this.crud.form.date_imputation = moment().format('YYYY-MM-DD')
        this.crud.form.observations = ''
        this.crud.form.staff_id = Helper.getStaffId()
        this.crud.form.suppliers_id = 0
        this.crud.form.suppliers = null
        this.crud.form.currency_id = 0
        this.crud.form.currency = null
        this.crud.form.remits_id = 0
        this.crud.form.remits = null
        this.crud.form.types_vouchers_id = 0
        this.crud.form.types_vouchers = null
        this.crud.form.letter = ''
        this.crud.form.point_sale = 0
        this.crud.form.number = 0
        this.crud.form.invoiceRelated = []
        this.crud.form.points_sales_id = 0
        this.crud.form.points_sales = null
        this.crud.form.purchase_category_id = 0
        this.crud.form.purchase_category = null
        this.crud.form.info_payment_id = 0
        this.crud.form.info_payment = null
        this.crud.form.payment = []
        this.crud.form.showPayment = true
        this.crud.form.ivaDetail = { net: 0, iva: 0, iva_condition_id: 0, iva_condition: null, detail: [] }
        this.crud.form.percepcionesDetail = { percepcion: 0, percepciones_id: 0, percepciones: null, detail: [] }
        this.crud.form.amount_total = 0
        this.resetControl = true
        this.pendingVoucherNameDefault = null
        this.pendingVoucherNamePrefixDefault = null
      },
      add() {
        // un alta normal no se vincula a ninguna renovación (el alta desde el
        // Monitor de servicios la vuelve a asignar después de llamar a add())
        this.servicesActivityId = null
        this.bankExpense = null
        if(this.purchaseGenerationOrigin == 'bankExpense') this.purchaseGenerationOrigin = null
        this.resetFormFields()
        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.active = true
        this.modal.form.title = 'Comprobante de Proveedor'
      },
      edit(item) {
        // editar otro comprobante no arrastra los movimientos de un Resumen bancario abierto
        this.bankExpense = null
        if(this.purchaseGenerationOrigin == 'bankExpense') this.purchaseGenerationOrigin = null
        this.crud.form.id = item.id
        this.crud.form.date = moment(item.date).format('YYYY-MM-DD')
        this.crud.form.date_expiration = moment(item.date_expiration).format('YYYY-MM-DD')
        this.crud.form.date_imputation = moment(item.date_imputation).format('YYYY-MM-DD')
        this.crud.form.observations = item.observations
        this.crud.form.staff_id = item.staff_id
        this.crud.form.suppliers_id = item.suppliers_id
        this.crud.form.suppliers = item.supplier
        this.crud.form.currency_id = item.currency_id
        this.crud.form.currency = item.currency
        this.crud.form.point_sale = item.point_sale
        this.crud.form.number = item.number
        this.crud.form.points_sales_id = item.points_sales_id
        this.crud.form.points_sales = item.points_sales
        this.crud.form.amount_total = item.amount_total
        this.crud.form.purchase_category_id = item.purchase_category_id
        this.crud.form.purchase_category = item.purchase_category
        this.crud.form.info_payment_id = item.info_payment_id
        this.crud.form.info_payment = item.info_payment
        this.crud.form.payment = []
        this.crud.form.showPayment = true

        this.loadTypeVouchersBySuppliers()
        this.forceRender()
        this.forceRenderAlt()
        setTimeout(()=>{
          this.crud.form.types_vouchers_id = item.types_vouchers_id
          this.crud.form.types_vouchers = item.type_voucher
          this.crud.form.letter = item.letter


          this.crud.form.ivaDetail = {
            net: 0,
            iva: 0,
            iva_condition_id: 0,
            iva_condition: null,
            detail: [],
          }
          if(item.net) {
            item.net.forEach(element => {
              this.crud.form.ivaDetail.detail.push({
                iva_condition_id: element.iva_conditions_id,
                iva_condition: element.iva_condition,
                net: element.amount_net,
                iva: element.amount_iva,
                total: element.amount_total,
              })
            });
          }

          this.crud.form.percepcionesDetail = {
            percepcion: 0,
            percepciones_id: 0,
            percepciones: null,
            detail: [],
          }
          if(item.perceptions) {
            item.perceptions.forEach(element => {
              this.crud.form.percepcionesDetail.detail.push({
                percepcion: element.amount_total,
                percepciones_id: element.perceptions_id,
                percepciones: element.perception,
              })
            });
          }

          this.crud.form.invoiceRelated = []
          if(item.purchase_related) {
            item.purchase_related.forEach(element => {
              this.crud.form.invoiceRelated.push({
                "type_voucher": element.purchase_related.type_voucher,
                "point_sale": element.purchase_related.point_sale,
                "number": element.purchase_related.number,
                "date": element.purchase_related.date,
                'amount': element.amount_total,
                "id": element.purchase_related.id,
              })
            });
          }
        },1500)

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.active = true
        this.modal.form.title = 'Editar Comprobante de Proveedor'
      },
      preSave() {
        if(this.bankExpense && !this.crud.form.id) {
          if(!this.crud.form.types_vouchers || this.crud.form.types_vouchers.type_balance != '+') {
            this.$awn.alert('El resumen bancario se carga con un comprobante que suma deuda')
            return
          }
          if(this.$funciones.compareMoney(this.crud.form.amount_total, this.bankExpense.amount) !== 0) {
            this.$awn.alert('El total del comprobante (' + Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrency}).format(this.crud.form.amount_total) +
                            ') tiene que ser igual a los movimientos bancarios (' + Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrency}).format(this.bankExpense.amount) + ')')
            return
          }
          this.crud.form.showPayment = true
          this.crud.form.payment = this.bankExpensePayment()
          this.modal.payment.title = "Pago con los movimientos bancarios"
          this.modal.payment.active = true
          return
        }
        if(
          !this.crud.form.id &&
          this.crud.form.showPayment &&
          this.crud.form.types_vouchers &&
          this.crud.form.types_vouchers.type_balance == '+'
        ) {
          this.saveAndPayment()
        } else {
          this.save()
        }
      },
      save() {
        this.warnRemitAmountDifferenceBeforeSave()

        this.confirmDialog('¿Desea continuar con la generación del comprobante?', {
          title: 'Generar Comprobante',
          okTitle: 'GENERAR'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = null
            if(this.crud.form.id) {
              result = serviceAPI.editarComprobante(this.crud.form);
            } else {
              result = serviceAPI.agregarComprobante(this.crud.form);
            }

            result.then((response) => {
              const returnToRemits = this.isGenerateFromRemitsRoute()
              const returnToBankExpense = !!this.bankExpense && !this.crud.form.id
              const servicesActivityId = this.crud.form.id ? null : this.servicesActivityId
              this.servicesActivityId = null

              this.modal.payment.active = false
              this.resetControl = true
              this.modal.form.active = false

              const finishSave = () => {
                loader.hide()
                this.$emit('saved', response)
                this.$awn.success("Comprobante generado con éxito");

                if(returnToRemits) {
                  this.$nextTick(() => {
                    this.returnToPurchaseRemits()
                  })
                }

                if(returnToBankExpense) {
                  this.$nextTick(() => {
                    this.returnToBankExpense()
                  })
                }

                if(servicesActivityId) {
                  this.$router.push({ name: 'ServicesStaffDisplayServicesCustomers' }).catch(() => {})
                }
              }

              const linkPromise = Promise.all([
                this.crud.form.remits_id ? this.linkRemitDetailsToPurchase(response.data) : Promise.resolve(true),
                servicesActivityId ? this.linkServicesActivityToPurchase(servicesActivityId, response.data) : Promise.resolve(true),
              ])

              linkPromise
                .then(() => {
                  finishSave()
                })
                .catch(() => {
                  finishSave()
                })
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      cancel() {
        this.confirmDialog('¿Desea cancelar el comprobante?', {
          title: 'Cancelar el Comprobante',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            this.modal.payment.active = false
            this.modal.form.active = false
            this.servicesActivityId = null

            this.returnToPurchaseRemits()
            this.returnToBankExpense()
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      saveAndPayment() {
        this.resetControl = true
        this.modal.payment.title = "Detalle del pago"
        this.modal.payment.active = true
      },
      storeFinances(values) {
        this.crud.form.payment = values
        this.crud.form.payment.totalFormat = Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrency}).format(this.crud.form.payment.total)
        this.resetControl = false
      },
      cancelPayment() {
        this.modal.payment.active = false
      },
      linkServicesActivityToPurchase(activityId, purchase) {
        if(!purchase || !purchase.id) {
          return Promise.resolve(false)
        }

        return serviceAPI.vincularComprobanteActividadServicio(activityId, purchase.id)
          .then(() => {
            this.$awn.success("Comprobante vinculado a la renovación del servicio")
            return true
          })
          .catch(error => {
            this.$awn.alert(Error.showError(error));
            return false
          })
      },
      linkRemitDetailsToPurchase(purchase) {
        if(!purchase || !purchase.id) {
          return Promise.resolve(false)
        }
        if(!this.crud.form.remits) {
          return Promise.resolve(false)
        }

        const details = this.getRemitDetailsForLink(this.crud.form.remits)
        if(!details.length) {
          return Promise.resolve(false)
        }

        return serviceAPI.guardarComprobanteRelacionadosRemitos({
          id: purchase.id,
          details: details,
        }).catch(error => {
          this.$awn.alert(Error.showError(error));
          return false
        })
      },
      warnRemitAmountDifferenceBeforeSave() {
        if(!this.crud.form.remits_id || !this.crud.form.remits) {
          return
        }
        const details = this.getRemitDetailsForLink(this.crud.form.remits)
        if(!details.length) {
          return
        }
        const isInvoiceA = this.crud.form.letter == 'A'
        // Los costos del remito son netos. Para Factura A se compara contra el
        // neto discriminado; para el resto, ambos importes se comparan con IVA.
        const remitTotal = isInvoiceA
          ? this.getRemitDetailsTotal(details)
          : this.getRemitAmountTotal(this.crud.form.remits)
        const invoiceAmount = isInvoiceA
          ? this.getSubtotal()
          : (parseFloat(this.crud.form.amount_total) || 0)
        if(Math.abs(invoiceAmount - remitTotal) > 0.009) {
          const fmt = (n) => Intl.NumberFormat('es-AR', { style: 'currency', currency: this.getCurrency || 'ARS' }).format(n)
          const amountLabel = isInvoiceA ? 'importe neto' : 'importe total'
          this.$awn.info(
            `Mensaje informativo: el ${amountLabel} de la factura (${fmt(invoiceAmount)}) difiere del ${amountLabel} de los ítems del remito (${fmt(remitTotal)}). Se vincularán conservando ambos importes.`
          )
        }
      },
      getRemitDetailsForLink(remit) {
        var items = []
        if(remit.details && remit.details.products) {
          remit.details.products.forEach(element => {
            if(element.id && !element.purchase_id) {
              items.push({
                id: element.id,
                check: true,
                quantity: element.quantity,
                price_cost: element.price_cost
              })
            }
          })
        }
        if(remit.details && remit.details.products_compound) {
          remit.details.products_compound.forEach(element => {
            if(element.id && !element.purchase_id) {
              items.push({
                id: element.id,
                check: true,
                quantity: element.quantity,
                price_cost: element.price_cost
              })
            }
          })
        }
        return items
      },
      getRemitDetailsTotal(details, onlyChecked=true) {
        var total = 0
        if(details && details.length) {
          details.forEach(element => {
            if(!onlyChecked || (element.check != undefined && element.check == true)) {
              var subtotal = parseFloat(element.quantity) * parseFloat(element.price_cost || 0)
              if(!isNaN(subtotal)) {
                total = total + subtotal
              }
            }
          })
        }
        return total
      },

      // ABM VALIDACIONES
      purchaseValidDetailGeneral() {
        if( this.crud.form.suppliers_id &&
            this.crud.form.types_vouchers_id &&
            this.crud.form.letter &&
            this.crud.form.point_sale &&
            this.crud.form.number &&
            this.crud.form.currency_id &&
            this.crud.form.currency &&
            this.crud.form.amount_total) {

          this.loadIvaCondition()
          this.loadPercepciones()

          return true;
        } else {
          if(!this.crud.form.suppliers_id) {
            this.$awn.alert("No se cargó el proveedor");
            return false;
          }

          if( !this.crud.form.types_vouchers_id ||
              !this.crud.form.letter ||
              !this.crud.form.point_sale ||
              !this.crud.form.number ) {
            this.$awn.alert("Faltan datos del comprobante");
            return false;
          }

          if(!this.crud.form.currency_id || !this.crud.form.currency) {
            this.$awn.alert("No se cargó la moneda");
            return false;
          }

          if(!this.crud.form.amount_total) {
            this.$awn.alert("No se cargó el importe");
            return false;
          }
        }
      },
      purchaseValidItemDetail() {
        if(this.crud.form.letter=='A') {
          if(this.getDiffTotal() == 0) {
            return true;
          } else {
            this.$awn.alert("El saldo declarado no es igual al desglose");
            return false;
          }
        } else {
          return true;
        }
      },
      purchaseValidCrudRelation() {
        if(this.crud.form.invoiceRelated.length) {
          const relatedCents = this.crud.form.invoiceRelated.reduce((total, element) => {
            return total + this.$funciones.toCents(element.amount)
          }, 0)

          if(relatedCents !== this.$funciones.toCents(this.crud.form.amount_total)) {
            this.$awn.alert("Falta imputar comprobantes");
            return false;
          } else {
            return true
          }
        } else {
          this.$awn.alert("Es obligatorio vincular una o mas factura a una nota de crédito o débito");
          return false;
        }
      },
      // ABM FLUJO
      loadSuppliers (object) {
        if(!this.crud.form.id) {
          if(object){
            if(this.crud.form.suppliers_id != object.id) {
              this.forceRender()
              this.forceRenderAlt()
            }

            this.crud.form.suppliers = object
            this.crud.form.suppliers_id = object.id

            if(object.data_fiscal) {
              if(object.data_fiscal.points_sales_id) {
                if(!this.crud.form.points_sales_id) {
                  this.crud.form.points_sales = object.data_fiscal.points_sales
                  this.crud.form.points_sales_id = object.data_fiscal.points_sales_id
                }
              }
              if(object.data_fiscal.methods_payment_id) {
                let days = parseInt(object.data_fiscal.methods_payment.term)
                this.crud.form.date_expiration = moment(this.crud.form.date).add(days,'d').format('YYYY-MM-DD')
              }
            }

            this.loadTypeVouchersBySuppliers()
          } else {
            this.crud.form.suppliers = null
            this.crud.form.suppliers_id = 0

            this.crud.form.points_sales = null
            this.crud.form.points_sales_id = 0

            this.cleanDataVoucher()
          }
        }
      },
      loadPointsSales (object) {
        if(object){
          this.crud.form.points_sales = object
          this.crud.form.points_sales_id = object.id

          this.loadTypeVouchersBySuppliers()
        } else {
          this.crud.form.points_sales = null
          this.crud.form.points_sales_id = 0

          this.cleanDataVoucher()
        }
      },
      loadCurrency (object) {
        if(object){
          this.crud.form.currency = object
          this.crud.form.currency_id = object.id
        } else {
          this.crud.form.currency = null
          this.crud.form.currency_id = 0
        }
      },
      loadPurchaseCategory(object) {
        if(object){
          this.crud.form.purchase_category = object
          this.crud.form.purchase_category_id = object.id
        } else {
          this.crud.form.purchase_category = null
          this.crud.form.purchase_category_id = 0
        }
      },
      loadInfoPayment(object) {
        if(object){
          this.crud.form.info_payment = object
          this.crud.form.info_payment_id = object.id
        } else {
          this.crud.form.info_payment = null
          this.crud.form.info_payment_id = 0
        }
      },
      loadTypeVouchersBySuppliers(referenceDefault=null) {
        if(this.crud.form.suppliers_id && this.crud.form.points_sales_id ) {
          let loader = this.$loading.show();

          this.cleanDataVoucher()
          this.voucherRequestKey = this.voucherRequestKey + 1
          const requestKey = this.voucherRequestKey
          var result = serviceAPI.obtenerVoucherBySupplier({
            suppliers_id: this.crud.form.suppliers_id,
            point_sale_id: this.crud.form.points_sales_id,
          });

          result.then((response) => {
            loader.hide()
            if(requestKey != this.voucherRequestKey) {
              return false
            }
            // RESUMEN BANCARIO solo desde los movimientos de una cuenta con la opción activa
            var data = response.data.filter(element => {
              return (element.name || '').trim().toUpperCase() != 'RESUMEN BANCARIO' || this.bankExpense || this.crud.form.id
            })
            this.arr.typeVouchers = data

            data.forEach(element => {
              this.arr.select.typeVouchers.push({
                value: element.id,
                text: element.name
              })
            });

            this.crud.form.types_vouchers_id = 0
            this.crud.form.letter = ''

            // this.pendingVoucherNameDefault (no el parámetro) porque loadSuppliers()/
            // loadPointsSales() pueden terminar llamando a este método más de una vez en
            // paralelo durante el preset desde remito (una vez por cada FindObject que
            // reacciona) — todas esas llamadas leen el mismo valor pendiente, así que no
            // importa cuál gane la carrera: el resultado final es siempre el mismo.
            // "reference" no sirve para identificar un tipo puntual: varios tipos de
            // comprobante comparten el mismo reference (ej. FACTURA A/B/C todas usan
            // "factura"), así que el default se busca por nombre exacto.
            var nameDefault = this.pendingVoucherNameDefault
            var namePrefixDefault = this.pendingVoucherNamePrefixDefault
            var selectVoucher = null
            if(nameDefault) {
              var target = nameDefault.trim().toUpperCase()
              selectVoucher = data.find(element => (element.name || '').trim().toUpperCase() === target)
            }
            if(!selectVoucher && namePrefixDefault) {
              // No busca "FACTURA A" puntual: toma la primera Factura A/B/C que aparezca
              // en la lista de tipos disponibles para este proveedor+punto de venta (no
              // siempre está la A, depende de la condición fiscal del proveedor).
              var prefix = namePrefixDefault.trim().toUpperCase()
              selectVoucher = data.find(element => (element.name || '').trim().toUpperCase().indexOf(prefix) === 0)
            }
            if(!selectVoucher && referenceDefault) {
              selectVoucher = data.find(element => element.reference == referenceDefault)
            }
            // En una carga manual no hay un tipo preferido: usar el primero
            // habilitado para el proveedor y punto de venta, como punto de partida.
            if(!selectVoucher && data.length) {
              selectVoucher = data[0]
            }
            if(selectVoucher) {
              // setLetter() (no la asignación manual) porque además de letter/types_vouchers_id
              // también repara ivaDetail/percepcionesDetail (cleanDataVoucher(), llamado arriba,
              // los deja en {} sin la clave "detail" que el backend espera) — mismo camino que
              // sigue la selección manual del combo.
              this.setLetter(selectVoucher.id)
            }
          })
          .catch(error => {
            loader.hide()
            if(requestKey != this.voucherRequestKey) {
              return false
            }
            this.$awn.alert(Error.showError(error));
          })
        }
      },
      setLetter(event) {
        if(!this.crud.form.id) {
          var item = null
          this.arr.typeVouchers.forEach(element => {
            if(element.id == event) {
              item = element
            }
          });
          this.crud.form.letter = item.letter
          this.crud.form.types_vouchers_id = item.id
          this.crud.form.types_vouchers = item

          this.crud.form.ivaDetail = {
            net: 0,
            iva: 0,
            iva_condition_id: 0,
            iva_condition: null,
            detail: [],
          }

          this.crud.form.percepcionesDetail = {
            percepcion: 0,
            percepciones_id: 0,
            percepciones: null,
            detail: [],
          }

          this.applyBankExpenseTaxes()
        }
      },
      cleanDataVoucher() {
        this.arr.typeVouchers = null
        this.arr.select.typeVouchers = []

        this.crud.form.letter = ''
        this.crud.form.types_vouchers_id = 0
        this.crud.form.types_vouchers = null

        this.crud.form.currency_id = 1
        this.crud.form.currency = {
          id: 1,
          code: 'ARS',
          symbol: '$',
          name: 'Peso',
        }

        this.crud.form.ivaDetail = {}
      },
      // LOAD IVA
      loadIvaCondition() {
        var result = serviceAPI.obtenerIvaCondition();

        result.then((response) => {
          var data = response.data
          this.arr.ivaCondition = data

          this.arr.select.ivaCondition = []
          data.forEach(element => {
            this.arr.select.ivaCondition.push({
              value: element.id,
              text: element.name
            })
          });

          this.crud.form.ivaDetail.iva_condition_id = 5
          this.crud.form.ivaDetail.iva_condition = this.arr.ivaCondition[4]
          this.applyBankExpenseTaxes()
        })
      },
      changeIvaCondition(event) {
        var item = null
        this.arr.ivaCondition.forEach(element => {
          if(element.id == event) {
            item = element
          }
        });

        if(!item) {
          return
        }

        this.crud.form.ivaDetail.iva_condition_id = item.id
        this.crud.form.ivaDetail.iva_condition = item

        this.crud.form.ivaDetail.iva =  ( parseFloat(this.crud.form.ivaDetail.net) * parseFloat(item.aliquot) ) / 100
        this.crud.form.ivaDetail.iva = parseFloat(this.crud.form.ivaDetail.iva.toFixed(2))
      },
      changeNet() {
        var item = null
        this.arr.ivaCondition.forEach(element => {
          if(element.id == this.crud.form.ivaDetail.iva_condition_id) {
            item = element
          }
        });
        // Sin condición de IVA elegida todavía no hay alícuota para calcular.
        if(!item) return

        this.crud.form.ivaDetail.iva_condition_id = item.id
        this.crud.form.ivaDetail.iva_condition = item

        this.crud.form.ivaDetail.iva =  ( parseFloat(this.crud.form.ivaDetail.net) * parseFloat(item.aliquot) ) / 100
        this.crud.form.ivaDetail.iva = parseFloat(this.crud.form.ivaDetail.iva.toFixed(2))
      },
      addItemIVA()  {
        if(!this.crud.form.ivaDetail.iva_condition_id) {
          this.$awn.alert("No se cargó la condición de IVA");
          return false;
        }

        if(!parseFloat(this.crud.form.ivaDetail.net)) {
          this.$awn.alert("No se cargó el importe neto");
          return false;
        }

        if( !parseFloat(this.crud.form.ivaDetail.iva) &&
            parseFloat(this.crud.form.ivaDetail.iva_condition.aliquot)>0) {
          this.$awn.alert("No se cargó el importe de IVA");
          return false;
        }

        this.crud.form.ivaDetail.detail.push({
          net: this.crud.form.ivaDetail.net,
          iva: this.crud.form.ivaDetail.iva,
          iva_condition: this.crud.form.ivaDetail.iva_condition,
          iva_condition_id: this.crud.form.ivaDetail.iva_condition_id,
        })

        this.crud.form.ivaDetail.net = 0
        this.crud.form.ivaDetail.iva = 0
        this.crud.form.ivaDetail.iva_condition_id = 5
        this.crud.form.ivaDetail.iva_condition = this.arr.ivaCondition[4]
      },
      removeItemIVA(index) {
        this.crud.form.ivaDetail.detail.splice(index, 1)
      },
      // LOAD PERCEPCIONES
      loadPercepciones() {
        var result = serviceAPI.obtenerPercepciones();

        result.then((response) => {
          var data = response.data
          this.arr.percepciones = data

          this.arr.select.percepciones = []
          data.forEach(element => {
            this.arr.select.percepciones.push({
              value: element.id,
              text: element.name
            })
          });
        })
      },
      changePercepciones(event) {
        var item = null
        this.arr.percepciones.forEach(element => {
          if(element.id == event) {
            item = element
          }
        });

        this.crud.form.percepcionesDetail.percepciones_id = item.id
        this.crud.form.percepcionesDetail.percepciones = item
      },
      addItemPercepcion() {
        if(!this.crud.form.percepcionesDetail.percepciones_id) {
          this.$awn.alert("No se cargó la Percepción");
          return false;
        }

        if(!parseFloat(this.crud.form.percepcionesDetail.percepcion)) {
          this.$awn.alert("No se cargó el importe de la Percepción");
          return false;
        }

        var sum = parseFloat(this.crud.form.percepcionesDetail.percepcion)
        this.crud.form.percepcionesDetail.detail.forEach(element => {
          sum = parseFloat(sum) + parseFloat(element.percepcion)
        })
        if(sum>this.crud.form.amount_total) {
          this.$awn.alert("Las percepciones no pueden ser mayor al total de la factura");
          return false;
        }

        this.crud.form.percepcionesDetail.detail.push({
          percepcion: this.crud.form.percepcionesDetail.percepcion,
          percepciones_id: this.crud.form.percepcionesDetail.percepciones_id,
          percepciones: this.crud.form.percepcionesDetail.percepciones,
        })

        this.crud.form.percepcionesDetail.percepcion = 0
        this.crud.form.percepcionesDetail.percepciones_id = 0
        this.crud.form.percepcionesDetail.percepciones = null
      },
      removeItemPercepcion(index) {
        this.crud.form.percepcionesDetail.detail.splice(index, 1)
      },
      // GET TOTALES
      getSubtotal() {
        var sum = 0
        if(this.crud.form.ivaDetail.detail) {
          this.crud.form.ivaDetail.detail.forEach(element => {
            sum = sum + parseFloat(element.net)
          });
        }
        return parseFloat(sum.toFixed(2))
      },
      getIvaTotal() {
        var sum = 0
        if(this.crud.form.ivaDetail.detail) {
          this.crud.form.ivaDetail.detail.forEach(element => {
            sum = sum + parseFloat(element.iva)
          });
        }
        return parseFloat(sum.toFixed(2))
      },
      getPercepcionesTotal() {
        var sum = 0

        if(this.crud.form.percepcionesDetail.detail) {
          this.crud.form.percepcionesDetail.detail.forEach(element => {
            sum = sum + parseFloat(element.percepcion)
          });
        }

        return parseFloat(sum.toFixed(2))
      },
      getTotal() {
        return this.getSubtotal() + this.getIvaTotal() + this.getPercepcionesTotal()
      },
      getDiffTotal() {
        return parseFloat(this.getTotal().toFixed(2)) - parseFloat(parseFloat(this.crud.form.amount_total).toFixed(2))
      },
      // INVOICE RELACIONADA EN NC
      getInvoiceRelated(event) {
        this.crud.form.invoiceRelated = event
      },
    }
  }
</script>
<style>
  .crud-purchase-wizard .wizard-header {
    padding: 0px;
  }
  .crud-purchase-wizard .wizard-card-footer {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 4px 0;
  }
  .crud-purchase-wizard .wizard-card-footer .wizard-footer-left,
  .crud-purchase-wizard .wizard-card-footer .wizard-footer-right {
    float: none !important;
  }
  .crud-purchase-wizard .wizard-card-footer .wizard-footer-right {
    margin-left: auto;
  }
  .crud-purchase-wizard .wizard-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 112px;
    height: 36px;
    padding: 6px 14px;
    border-width: 1px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: var(--app-font-semibold);
    box-shadow: none;
    transition: background-color .15s ease, border-color .15s ease, color .15s ease;
  }
  .crud-purchase-wizard .wizard-footer-left .wizard-btn::before,
  .crud-purchase-wizard .wizard-footer-right .wizard-btn::after {
    font-family: 'Material Symbols Rounded';
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-feature-settings: 'liga';
    line-height: 1;
  }
  .crud-purchase-wizard .wizard-footer-left .wizard-btn::before {
    content: 'arrow_back';
    margin-right: 6px;
  }
  .crud-purchase-wizard .wizard-footer-right .wizard-btn::after {
    content: 'arrow_forward';
    margin-left: 6px;
  }
  .crud-purchase-wizard .wizard-footer-left .wizard-btn {
    background-color: var(--app-color-surface) !important;
    border-color: var(--app-color-border-strong) !important;
    color: var(--app-color-text-secondary) !important;
  }
  .crud-purchase-wizard .wizard-footer-left .wizard-btn:hover {
    background-color: var(--app-color-surface-subtle) !important;
    color: var(--app-color-text) !important;
  }
  .crud-purchase-wizard .wizard-footer-right .wizard-btn {
    background-color: var(--app-color-primary) !important;
    border-color: var(--app-color-primary) !important;
    color: #fff !important;
  }
  .crud-purchase-wizard .wizard-footer-right .wizard-btn:hover {
    filter: brightness(.94);
  }
  @media (max-width: 767.98px) {
    .crud-purchase-wizard .wizard-card-footer {
      gap: 8px;
      padding: 12px 0 0;
    }
    .crud-purchase-wizard .wizard-footer-left,
    .crud-purchase-wizard .wizard-footer-right {
      display: flex;
      flex: 1 1 0;
    }
    .crud-purchase-wizard .wizard-card-footer .wizard-footer-right {
      margin-left: 0;
    }
    .crud-purchase-wizard .wizard-footer-left > span,
    .crud-purchase-wizard .wizard-footer-right > span {
      display: block;
      width: 100%;
    }
    .crud-purchase-wizard .wizard-btn {
      width: 100%;
      min-width: 0;
    }
  }
  .crud_purchase_alert_from {
    padding: 5px 10px;
    margin-bottom: 0px;
  }
  .crud-purchase-tax-tabs .nav-tabs {
    border-bottom-color: var(--app-color-border);
  }
  .crud-purchase-tax-tabs .nav-link {
    display: inline-flex;
    align-items: center;
    color: var(--app-color-text-secondary);
  }
  .crud-purchase-tax-tabs .nav-link.active {
    color: var(--app-color-primary);
    font-weight: var(--app-font-semibold);
  }
  .crud-purchase-tax-tabs .nav-link .badge {
    min-width: 20px;
  }
  .crud-purchase-tax-guide {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 10px;
    padding: 8px 10px;
    border: 1px solid var(--app-color-border);
    border-radius: 7px;
    background: var(--app-color-surface-subtle);
    color: var(--app-color-text-secondary);
    font-size: 0.82rem;
    line-height: 1.45;
  }
  .crud-purchase-tax-guide .app-icon {
    flex: 0 0 auto;
    margin-top: 1px;
    color: var(--app-color-primary);
  }
  .crud-purchase-tax-guide b {
    color: var(--app-color-text);
  }
  .crud-purchase-tax-form {
    padding: 10px 12px;
    border: 1px solid var(--app-color-border);
    border-radius: 7px;
    background: var(--app-color-surface);
  }
  .crud-purchase-tax-form .form-group {
    margin-bottom: 0;
  }
  .crud-purchase-tax-form__add {
    margin-bottom: 1px;
  }
  .crud-purchase-tax-detail {
    margin-top: 12px;
    border-top: 1px solid var(--app-color-border);
  }
  .crud-purchase-tax-table {
    overflow: hidden;
    margin-top: 12px;
    border: 1px solid var(--app-color-border);
    border-radius: 7px;
    background: var(--app-color-surface);
  }
  .crud-purchase-tax-table__heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 34px;
    padding: 6px 10px;
    border-bottom: 1px solid var(--app-color-border);
    background: var(--app-color-surface-subtle);
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
  }
  .crud-purchase-tax-table__heading span {
    display: inline-flex;
    align-items: center;
    gap: 5px;
  }
  .crud-purchase-tax-label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    border: 1px solid var(--app-color-primary-200);
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary-active);
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
  }
  .crud-purchase-tax-table .app-table {
    margin-bottom: 0;
  }
  .btn.crud-purchase-tax-remove-btn {
    width: 32px;
    height: 32px;
    font-size: 18px;
  }
  .crud-purchase-tax-detail .app-empty-state {
    margin-top: 12px;
  }
  .crud-purchase-voucher-fields {
    padding: 10px 12px 2px;
    border: 1px solid #b7dce8;
    border-radius: 6px;
    background: #f1fbff;
  }
  .crud-purchase-voucher-fields__title {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
    color: #17617d;
    font-size: 0.8rem;
    font-weight: var(--app-font-semibold);
  }
  @media (max-width: 767.98px) {
    .crud-purchase-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
  }

  /* Cajita de totales (Subtotal/IVA/Percepciones/Importe Final/Diferencia)
     del wizard — reemplaza la franja sólida oscura por una card tokenizada
     (ver docs/modal-interfaces, sección 7). */
  .crud-purchase-totals {
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
    padding: 10px 12px;
  }
  .crud-purchase-totals--taxes {
    overflow: hidden;
    padding: 0;
    background: var(--app-color-surface);
  }
  .crud-purchase-totals__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 9px 12px;
    border-bottom: 1px solid var(--app-color-border);
    background: var(--app-color-surface-subtle);
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-xs);
  }
  .crud-purchase-totals__header > span:first-child {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    color: var(--app-color-text);
    font-weight: var(--app-font-semibold);
  }
  .crud-purchase-totals--taxes .crud-purchase-totals__row {
    padding: 7px 12px;
  }
  .crud-purchase-totals__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 4px 0;
  }
  .crud-purchase-totals__row + .crud-purchase-totals__row {
    border-top: 1px dashed var(--app-color-border);
  }
  .crud-purchase-totals__row--total {
    border-top: 2px solid var(--app-color-primary) !important;
    margin-top: 4px;
    padding-top: 8px;
  }
  .crud-purchase-totals--taxes .crud-purchase-totals__row--total {
    margin-top: 0;
    padding-top: 8px;
    padding-bottom: 8px;
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary-active);
  }
  .crud-purchase-totals__row--difference {
    font-size: var(--app-text-sm);
  }
  .crud-purchase-totals__row--balanced {
    background: var(--app-color-success-soft);
    color: var(--app-color-success-hover);
  }
  .crud-purchase-totals__row--unbalanced {
    background: var(--app-color-danger-soft);
    color: var(--app-color-danger-hover);
  }
  .crud-purchase-totals__label {
    flex: 1 1 auto;
    min-width: 0;
  }
  .crud-purchase-totals__value {
    flex: 0 0 auto;
    white-space: nowrap;
    font-weight: var(--app-font-semibold);
  }
</style>
